import { cn } from '@/lib/utils';
import { PropsWithChildren } from 'react';

interface ICardProps extends PropsWithChildren {
  className?: string;
}
export const AppCard = ({ children, ...props }: ICardProps) => {
  return (
    <div
      {...props}
      className={cn(
        'overflow-hidden rounded-xl border border-coal-300 bg-white p-5 shadow-card',
        props?.className
      )}
    >
      {children}
    </div>
  );
};
